import React, { useEffect, useState } from 'react';
// Shared end time across all CountdownTimer instances
let sharedEndTime: number | null = null;
interface CountdownTimerProps {
  initialMinutes?: number;
  className?: string;
  showLabels?: boolean;
}
export function CountdownTimer({
  initialMinutes = 15,
  className = '',
  showLabels = false
}: CountdownTimerProps) {
  if (sharedEndTime === null) {
    sharedEndTime = Date.now() + initialMinutes * 60 * 1000;
  }
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60);
  useEffect(() => {
    const tick = () => {
      const remaining = Math.max(0, Math.floor((sharedEndTime! - Date.now()) / 1000));
      if (remaining <= 0) {
        sharedEndTime = Date.now() + initialMinutes * 60 * 1000;
        setTimeLeft(initialMinutes * 60);
      } else {
        setTimeLeft(remaining);
      }
    };
    tick();
    const interval = setInterval(tick, 500);
    return () => clearInterval(interval);
  }, [initialMinutes]);
  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  if (showLabels) {
    return <div className={`flex items-center gap-3 font-bold ${className}`} data-id="element-295">
        <div className="flex flex-col items-center" data-id="element-296">
          <span className="bg-[#E74C3C] text-white px-4 py-3 rounded-lg text-4xl md:text-5xl font-extrabold shadow-lg" data-id="element-297">
            {minutes}
          </span>
          <span className="text-xs mt-2 uppercase tracking-wider text-gray-300 font-semibold" data-id="element-298">
            MINUTOS
          </span>
        </div>
        <span className="text-4xl md:text-5xl text-white font-extrabold pb-6" data-id="element-299">
          :
        </span>
        <div className="flex flex-col items-center" data-id="element-300">
          <span className="bg-[#E74C3C] text-white px-4 py-3 rounded-lg text-4xl md:text-5xl font-extrabold shadow-lg" data-id="element-301">
            {seconds}
          </span>
          <span className="text-xs mt-2 uppercase tracking-wider text-gray-300 font-semibold" data-id="element-302">
            SEGUNDOS
          </span>
        </div>
      </div>;
  }
  return <span className={`font-mono font-bold ${className}`} data-id="element-303">
      {minutes}:{seconds}
    </span>;
}